<template>
  <div class="cooperation">
    <div class="banner_box">
      <Banner></Banner>
    </div>
    <div>
      <div class="title_box">合作流程</div>
      <div class="cooperation_box">
        <div class="cooperation_li">
          <div class="img_box">
            <div class="point">
              <img src="../../static/images/img/point.png"
                   alt="">
            </div>
            <div class="img">
              <img src="../../static/images/img/guanyuwomen/liucheng1.png"
                   alt="">
              <div class="cover_box">
                <h5>
                  step
                </h5>
                <p>1</p>
              </div>
              <div class="border1"></div>
              <div class="border2"></div>
              <div class="border3"></div>
              <div class="border4"></div>
            </div>
          </div>
          <div class="text_box">
            <div class="title">
              需求调研
            </div>
            <div class="text">
              需求调研对于一个应用软件开发来说，是一个系统开发的开始阶段，它的输出“软件需求分析报告”是设计阶段的输入，需求调研的质量对于一个应用软件来说，是一个极其重要的阶段，它的质量在一定程度上来说决定了一个软件的交付结果。
            </div>
          </div>
        </div>
        <div class="cooperation_li">
          <div class="text_box"
               style="text-align: right;">
            <div class="title">
              开发评估及签订合同
            </div>
            <div class="text">
              项目评估就是对项目的结构、功能、环境匹配性、可操作性、可持续性进行系统的价值研判的活动。包括洽谈细节，置顶开发方案，预估开发时间，客户审定，修改合格后签订合同，支付预付款。
            </div>
          </div>
          <div class="img_box">
            <div class="point">
              <img src="../../static/images/img/point.png"
                   alt="">
            </div>
            <div class="img">
              <img src="../../static/images/img/guanyuwomen/liucheng2.png"
                   alt="">
              <div class="cover_box">
                <h5>
                  step
                </h5>
                <p>2</p>
              </div>
              <div class="border1"></div>
              <div class="border2"></div>
              <div class="border3"></div>
              <div class="border4"></div>
            </div>
          </div>
        </div>
        <div class="cooperation_li">
          <div class="img_box">
            <div class="point">
              <img src="../../static/images/img/point.png"
                   alt="">
            </div>
            <div class="img">
              <img src="../../static/images/img/guanyuwomen/liucheng3.png"
                   alt="">
              <div class="cover_box">
                <h5>
                  step
                </h5>
                <p>3</p>
              </div>
              <div class="border1"></div>
              <div class="border2"></div>
              <div class="border3"></div>
              <div class="border4"></div>
            </div>
          </div>
          <div class="text_box">
            <div class="title">
              交互原型设计
            </div>
            <div class="text">
              原型设计是交互设计师与PD、PM、网站开发工程师沟通的最好工具。而该块的设计在原则上必须是交互设计师的产物，交互设计以用户为中心的理念会贯穿整个产品。利用交互设计师专业的眼光与经验直接导致该产品的可用性。
            </div>
          </div>
        </div>
        <div class="cooperation_li">
          <div class="text_box"
               style="text-align: right;">
            <div class="title">
              视觉UI设计
            </div>
            <div class="text">
              UI即泛指用户的操作界面，包含移动APP，网页等。UI设计主要指界面的样式，美观程度。而使用上，对软件的人机交互、操作逻辑、界面美观的整体设计则是同样重要的另一个门道。
            </div>
          </div>
          <div class="img_box">
            <div class="point">
              <img src="../../static/images/img/point.png"
                   alt="">
            </div>
            <div class="img">
              <img src="../../static/images/img/guanyuwomen/liucheng4.png"
                   alt="">
              <div class="cover_box">
                <h5>
                  step
                </h5>
                <p>4</p>
              </div>
              <div class="border1"></div>
              <div class="border2"></div>
              <div class="border3"></div>
              <div class="border4"></div>
            </div>
          </div>
        </div>
        <div class="cooperation_li">
          <div class="img_box">
            <div class="point">
              <img src="../../static/images/img/point.png"
                   alt="">
            </div>
            <div class="img">
              <img src="../../static/images/img/guanyuwomen/liucheng5.png"
                   alt="">
              <div class="cover_box">
                <h5>
                  step
                </h5>
                <p>5</p>
              </div>
              <div class="border1"></div>
              <div class="border2"></div>
              <div class="border3"></div>
              <div class="border4"></div>
            </div>
          </div>
          <div class="text_box">
            <div class="title">
              应用开发测试
            </div>
            <div class="text">
              应用软件开发是指使用程序语言C#、java、 c++、vb等高级语言编写，主要是用于商业、生活应用的软件的开发。软件测试是描述一种用来促进鉴定软件的正确性、完整性、安全性和质量的过程。
            </div>
          </div>
        </div>
        <div class="cooperation_li">
          <div class="text_box"
               style="text-align: right;">
            <div class="title">
              应用验收及推广
            </div>
            <div class="text">
              验收测试是部署软件之前的最后一个测试操作。在软件产品完成了单元测试、集成测试和系统测试之后，产品发布之前所进行的软件测试活动。它是技术测试的最后阶段，也称为交付测试。测试合格后进行支付尾款和项目移交。
            </div>
          </div>
          <div class="img_box">
            <div class="img">
              <img src="../../static/images/img/guanyuwomen/liucheng5.png"
                   alt="">
              <div class="cover_box">
                <h5>
                  step
                </h5>
                <p>6</p>
              </div>
              <div class="border1"></div>
              <div class="border2"></div>
              <div class="border3"></div>
              <div class="border4"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Banner from "@/components/banner.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Banner,
    Footer,
  },
}
</script>
<style lang="scss" scoped>
.cooperation {
  text-align: center;
  .title_box {
    display: inline-block;
    position: relative;
    font-size: 0.2103rem;
    font-family: MicrosoftYaHei;
    color: #000;
    opacity: 1;
    margin: 0.225rem 0 0.1383rem;
  }
  .title_box::before {
    content: "";
    position: absolute;
    left: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_left.png");
    background-size: 100% 100%;
  }
  .title_box::after {
    content: "";
    position: absolute;
    right: -0.4083rem;
    top: 58%;
    transform: translateY(-50%);
    width: 0.2083rem;
    height: 0.2188rem;
    background-image: url("../../static/images/icon/title_right.png");
    background-size: 100% 100%;
  }
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .cooperation_box {
    padding: 0.1563rem 2.1875rem;
    margin-bottom: 0.2604rem;
    .cooperation_li {
      display: flex;
      justify-content: space-between;
      .img_box {
        position: relative;
        width: 2.0208rem;
        .point {
          position: absolute;
          bottom: -23%;
          right: -78%;
          width: 1.5625rem;
          height: 1.0417rem;
          z-index: 9;
        }
        .img {
          position: relative;
          width: 2.0208rem;
          height: 1.7396rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: pink;
          .border1 {
            height: 50%;
            width: 50%;
            position: absolute;
            top: -13%;
            left: -31%;
            background-color: #fff;
            transform: rotate(-60deg);
          }
          .border2 {
            height: 50%;
            width: 50%;
            position: absolute;
            top: -13%;
            right: -31%;
            background-color: #fff;
            transform: rotate(60deg);
          }
          .border3 {
            height: 50%;
            width: 50%;
            position: absolute;
            bottom: -13%;
            right: -31%;
            background-color: #fff;
            transform: rotate(-60deg);
          }
          .border4 {
            height: 50%;
            width: 50%;
            position: absolute;
            bottom: -13%;
            left: -31%;
            background-color: #fff;
            transform: rotate(60deg);
          }
          .cover_box {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            background-color: #00000050;
            text-align: center;
            h5 {
              font-size: 0.4688rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 0.6313rem;
              color: #ffffff;
              letter-spacing: 0.0052rem;
              opacity: 1;
              margin-top: 0.2542rem;
            }
            p {
              font-size: 0.4688rem;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 0.599rem;
              color: #ffffff;
              // letter-spacing: px;
              opacity: 1;
            }
          }
        }
      }
      .img_box:nth-child(even) {
        .point {
          position: absolute;
          bottom: -23%;
          left: -78%;
          width: 1.5625rem;
          height: 1.0417rem;
          z-index: 9;
          transform: rotate(105deg);
        }
      }
      .text_box {
        width: 2.7604rem;
        text-align: left;
        min-height: 1.25rem;
        margin: 0.504rem 0rem;
        .title {
          font-size: 0.1563rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 0.3385rem;
          color: #000000;
          letter-spacing: 0.0052rem;
          opacity: 1;
        }
        .text {
          font-size: 0.1042rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 0.1875rem;
          color: #999999;
          letter-spacing: 0.0052rem;
          opacity: 1;
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
</style>